var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "main-header" } }, [
    _vm.currentEnvironment
      ? _c(
          "div",
          { staticClass: "notification-block notification-block-top" },
          [_vm._m(0)]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("header", { staticClass: "col-12 float-left" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass:
              "header-logo col-5 col-sm-6 col-md-4 col-lg-2 float-left"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "logo-left" },
                [
                  _c("router-link", { attrs: { to: { path: "/" } } }, [
                    _c("img", {
                      attrs: {
                        src: "/static/images/vvg-home-logo.png",
                        alt: "Velocity Truck Center"
                      }
                    })
                  ])
                ],
                1
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "middle-menu col-6 col-sm-6 col-md-7 col-lg-7 float-left"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("i", { staticClass: "fa fa-close" }),
              _vm._v(" "),
              _c("ul", { staticClass: "snip1135" }, [
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/ourstory" },
                          "data-hover": "Our Story",
                          title: "Our Story"
                        }
                      },
                      [_vm._v(" Our Story ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/benefits" },
                          "data-hover": "Benefits",
                          title: "Benefits"
                        }
                      },
                      [_vm._v(" Benefits ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/401kplan" },
                          "data-hover": "401K",
                          title: "401K"
                        }
                      },
                      [_vm._v(" 401K ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/day-force-101" },
                          "data-hover": "Dayforce 101",
                          title: "Dayforce 101"
                        }
                      },
                      [_vm._v(" Dayforce 101 ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/formspolicies" },
                          "data-hover": "Policies and Forms",
                          title: "Policies and Forms"
                        }
                      },
                      [_vm._v(" Policies and Forms ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/faq" },
                          "data-hover": "FAQs",
                          title: "FAQs"
                        }
                      },
                      [_vm._v(" FAQs ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: _vm.safetyURL,
                        target: "_blank",
                        "data-hover": "Safety Zone",
                        title: "Safety Zone"
                      }
                    },
                    [_vm._v(" Safety Zone ")]
                  )
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "my-account-name col-5 col-sm-6 col-md-6 col-lg-2 float-left"
          },
          [
            _vm.roleId <= 2 ||
            _vm.userPermissions.indexOf("add_contact_extension") > -1 ||
            _vm.userPermissions.indexOf("allow_user_management_module") > -1
              ? [
                  _vm.roleId > 1 &&
                  (_vm.userPermissions.indexOf("add_contact_extension") > -1 ||
                    _vm.userPermissions.indexOf(
                      "allow_user_management_module"
                    ) > -1)
                    ? [
                        _vm.userPermissions.indexOf("add_contact_extension") >
                          -1 ||
                        _vm.userPermissions.indexOf(
                          "allow_user_management_module"
                        ) > -1
                          ? [
                              _c(
                                "router-link",
                                {
                                  staticClass: "ac-left-des",
                                  attrs: {
                                    to: {
                                      name:
                                        _vm.userPermissions.indexOf(
                                          "allow_user_management_module"
                                        ) > -1
                                          ? "ListUser"
                                          : "ListContact"
                                    },
                                    title: "My Account"
                                  }
                                },
                                [
                                  _c("i", { staticClass: "hi-icon hr-user" }),
                                  _vm._v(" "),
                                  _c("p", [_vm._v("My Account ")])
                                ]
                              )
                            ]
                          : _vm._e()
                      ]
                    : _vm.roleId == 2
                    ? [
                        _c(
                          "router-link",
                          {
                            staticClass: "ac-left-des",
                            attrs: {
                              to: { name: "ListTalentProfile" },
                              title: "My Account"
                            }
                          },
                          [
                            _c("i", { staticClass: "hi-icon hr-user" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("My Account ")])
                          ]
                        )
                      ]
                    : [
                        _c(
                          "router-link",
                          {
                            staticClass: "ac-left-des",
                            attrs: {
                              to: { name: "ListBenefits" },
                              title: "My Account"
                            }
                          },
                          [
                            _c("i", { staticClass: "hi-icon hr-user" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("My Account ")])
                          ]
                        )
                      ]
                ]
              : void 0,
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "home-email-icon" },
              [
                _c(
                  "router-link",
                  { attrs: { to: { path: "/contact" }, title: "Contact HR" } },
                  [_c("i", { staticClass: "hi-icon hr-email" })]
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.userPermissions.indexOf("access_social_media_calendar") > -1
              ? [
                  _c(
                    "div",
                    { staticClass: "home-email-icon" },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: { name: "SocialMediaCalendar" },
                            title: "Social Media Calendar"
                          }
                        },
                        [_c("i", { staticClass: "fa fa-calendar" })]
                      )
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._m(1)
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "home-menu-right col-2 col-sm-6 col-md-2 col-lg-1 float-left"
          },
          [
            _c(
              "div",
              {
                staticClass: "button_container",
                attrs: { id: "toggle" },
                on: { click: _vm.menuToggle }
              },
              [
                _c("span", { staticClass: "top" }),
                _vm._v(" "),
                _c("span", { staticClass: "middle" }),
                _vm._v(" "),
                _c("span", { staticClass: "bottom" })
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "overlay", attrs: { id: "overlay" } }, [
              _c("nav", { staticClass: "overlay-menu" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "menu-hover-full col-12 float-l" }, [
                    _c(
                      "ul",
                      { staticClass: "snip1135 float-l width-full" },
                      [
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/meethrteam" },
                                  "data-hover": "Meet the HR Team"
                                }
                              },
                              [_vm._v("Meet the HR Team")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/ourstory" },
                                  "data-hover": "Our Story"
                                }
                              },
                              [_vm._v("Our Story")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/hrcalendar" },
                                  "data-hover": "HR Calendar"
                                }
                              },
                              [_vm._v("HR Calendar")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.userPermissions.indexOf(
                          "access_social_media_calendar"
                        ) > -1
                          ? [
                              _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { name: "SocialMediaCalendar" },
                                        "data-hover": "Social Media Calendar"
                                      }
                                    },
                                    [_vm._v("Social Media Calendar")]
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.roleId <= 2
                          ? [
                              _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { path: "/leadershipdevelopment" },
                                        "data-hover":
                                          "Leadership and Development"
                                      }
                                    },
                                    [_vm._v("Leadership and Development")]
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: "/benefits",
                                  "data-hover": "Benefits"
                                }
                              },
                              [_vm._v(" Benefits ")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/wellness" },
                                  "data-hover": "Wellness"
                                }
                              },
                              [_vm._v("Wellness")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/employeerecognition" },
                                  "data-hover": "Employee Recognition"
                                }
                              },
                              [_vm._v("Employee Recognition")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/formspolicies" },
                                  "data-hover": "Policies and Forms"
                                }
                              },
                              [_vm._v("Policies and Forms")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/employeeperksprogram" },
                                  "data-hover": "Employee Perks"
                                }
                              },
                              [_vm._v("Employee Perks")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/surveys" },
                                  "data-hover": "Surveys"
                                }
                              },
                              [_vm._v("Surveys")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/gallery" },
                                  "data-hover": "Photo Gallery"
                                }
                              },
                              [_vm._v("Photo Gallery")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/day-force-101" },
                                  "data-hover": "Dayforce 101"
                                }
                              },
                              [_vm._v("Dayforce 101")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/401kplan" },
                                  "data-hover": "401K"
                                }
                              },
                              [_vm._v("401K")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/faq" },
                                  "data-hover": "FAQs"
                                }
                              },
                              [_vm._v("FAQs")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.safetyURL,
                                target: "_blank",
                                "data-hover": "Safety Zone"
                              }
                            },
                            [_vm._v("Safety Zone")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "ViewLocationDepartments",
                                    params: { slug: _vm.extension_slug }
                                  },
                                  "data-hover": "Extension Directory"
                                }
                              },
                              [_vm._v("Extension Directory")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/contact" },
                                  "data-hover": "Contact"
                                }
                              },
                              [_vm._v("Contact")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: { path: "/forum" },
                                  "data-hover": "Forum"
                                }
                              },
                              [_vm._v("Forum")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.roleId <= 2
                          ? [
                              _c(
                                "li",
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: { path: "/managertoolbox" },
                                        "data-hover": "Manager Tool Box"
                                      }
                                    },
                                    [_vm._v("Manager Tool Box")]
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                "data-hover": "Log Out"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.logout()
                                }
                              }
                            },
                            [_vm._v("Log Out")]
                          )
                        ])
                      ],
                      2
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "alert alert-primary alert-dismissible",
        attrs: { role: "alert", "aria-live": "polite", "aria-atomic": "true" }
      },
      [
        _c("div", { staticClass: "scroll-left" }, [
          _c("p", [_vm._v("This is Test Environment !")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      { staticClass: "home-responsive-menu-right", attrs: { type: "button" } },
      [_c("i", { staticClass: "hi-icon hr-menu" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { display: "none" },
        attrs: { href: "#", id: "scroll", title: "Scroll to Top" }
      },
      [_vm._v("Top"), _c("span")]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a5fdd6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a5fdd6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = null
// module chunks = 